import { DbBrokerInvoice } from '@numeo/types-core'
import axios from 'axios'

interface GetInvoiceReportsRequest {
    fromDate: string
    toDate: string
}

interface GetInvoiceReportsResponse {
    success: boolean
    invoices: DbBrokerInvoice[]
    message?: string
    error?: string
}

export const invoiceReportsApi = {
    /**
     * Fetch invoice reports within a date range
     */
    async getInvoiceReports(params: GetInvoiceReportsRequest): Promise<GetInvoiceReportsResponse> {
        try {
            // The route is registered at '/invoice-reports' in gluon/routes.ts
            // In the frontend, axios is likely configured with a base URL that points to the gluon service
            const response = await axios.get<GetInvoiceReportsResponse>('/invoice-reports', { params })
            return response.data
        } catch (error) {
            if (axios.isAxiosError<GetInvoiceReportsResponse>(error) && error.response?.data) {
                return error.response.data
            }
            throw new Error('Failed to fetch invoice reports')
        }
    },
}
